<script setup lang="ts">
// Props can be passed from markdown frontmatter
withDefaults(defineProps<{
  prosTitle?: string
  consTitle?: string
  pros?: Array<{ title: string, description?: string }>
  cons?: Array<{ title: string, description?: string }>
}>(), {
  prosTitle: 'Voordelen',
  consTitle: 'Nadelen',
})

const columnClasses = ' p-6 space-y-4'
const titleClasses = 'font-medium text-highlighted '
const descriptionClasses = 'text-sm text-muted'
</script>

<template>
  <div class="my-6 grid grid-cols-1 md:grid-cols-2 gap-px rounded-lg border border-default overflow-hidden bg-green-50/75">
    <!-- Pros Column -->
    <div
      class="bg-green-50/75"
      :class="[columnClasses]"
    >
      <h3 class="font-semibold">
        {{ prosTitle }}
      </h3>
      <ul
        role="list"
        class="space-y-4"
      >
        <li
          v-for="(pro, index) in pros"
          :key="index"
          class="flex items-start gap-3"
        >
          <UIcon
            name="i-lucide-circle-plus"
            class="w-6 h-6 text-success shrink-0"
            aria-hidden="true"
          />
          <div class="min-w-0">
            <h4 :class="titleClasses">
              {{ pro.title }}
            </h4>
            <p
              v-if="pro.description"
              :class="descriptionClasses"
            >
              {{ pro.description }}
            </p>
          </div>
        </li>
      </ul>
    </div>

    <!-- Cons Column -->
    <div
      v-if="cons && cons.length > 0"
      class="bg-red-50/75"
      :class="[columnClasses]"
    >
      <h3 class="font-semibold">
        {{ consTitle }}
      </h3>
      <ul
        role="list"
        class="space-y-4"
      >
        <li
          v-for="(con, index) in cons"
          :key="index"
          class="flex items-start gap-3"
        >
          <UIcon
            name="i-lucide-circle-minus"
            class="w-6 h-6 text-error  shrink-0"
            aria-hidden="true"
          />
          <div class="min-w-0">
            <h4 :class="titleClasses">
              {{ con.title }}
            </h4>
            <p
              v-if="con.description"
              :class="descriptionClasses"
            >
              {{ con.description }}
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
